import React, { useEffect, useState } from 'react';

import ShareIcon from '@/assets/icons/share.svg';

import { isBrowser } from '../../helpers/is-browser';
interface ShareProps {
  className?: string;
}
interface ShareData {
  url: string;
  text: string;
}
export const Share = ({ className }: ShareProps) => {
  const [showShare, setShowShare] = useState<boolean>(false);
  useEffect(() => {
    if (!isBrowser) return;
    if (typeof navigator.share === 'function') {
      setShowShare(true);
    }
  }, []);

  const openShareDialog = () => {
    const text = isBrowser ? document.title : '';
    const url = isBrowser ? location.href : '';
    const shareData: ShareData = { url, text };

    navigator.share(shareData).catch(() => {});
  };
  return (
    <button
      onClick={openShareDialog}
      className={`${className} grid h-10 w-10 place-items-center rounded-full bg-brand-white text-icon-dark outline-0 transition-all lg:hover:bg-neutral-grey-100 focus-visible:bg-brand-white focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-icon-dark active:bg-neutral-grey-200 ${
        showShare ? '' : 'hidden'
      }`}
    >
      <ShareIcon className="h-6 w-6" />
    </button>
  );
};
